import React, { Fragment } from 'react';
import _ from 'lodash';

import {
    Card,
    CardBody,
    CardHeader,
    Collapse,
    FormGroup,
    Input,
    Label
} from 'reactstrap';

import qs from 'qs';
import { withRouter } from 'react-router-dom';

import { urlify } from '../../utils';
import CollapseButton from '../dumb/collapseButton';
import baseFilter from './baseFilter';


class CancerTypeFilter extends baseFilter {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            filters: {},
            activeCount: 0
        };

        this.aggregates = {
            'sample.cancer_type.name': 'count'
        };

        // Guards against re-fetching more than once when the URL
        // already has a cancer_type filter on first mount (see
        // processResponse for why this is needed).
        this.hasSyncedInitialSelection = false;

        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        this.toggleCollapse = this.toggleCollapse.bind(this);
        this.processResponse = this.processResponse.bind(this);
        this.updateAPIURL = this.updateAPIURL.bind(this);
    }


    /**
     * Get currently selected cancer types from the URL.
     */
    getActiveCancerTypes() {
        const current_qs = qs.parse(
            this.props.location.search,
            {
                ignoreQueryPrefix: true
            }
        );

        if (!current_qs.cancer_type) {
            return [];
        }

        return _.split(current_qs.cancer_type, '_');
    }


    /**
     * Convert the URL values into API filter values.
     */
    getSelectedCancerTypes() {
        const activeCancerTypes = this.getActiveCancerTypes();

        return _.keys(this.state.filters).filter(cancerType => {
            return activeCancerTypes.indexOf(urlify(cancerType)) !== -1;
        });
    }


    updateAPIURL(current_api_qs, newlistprops) {

        const new_qs = qs.parse(
            newlistprops.location.search,
            {
                ignoreQueryPrefix: true
            }
        );

        const selectedValues = new_qs.cancer_type
            ? _.split(new_qs.cancer_type, '_')
            : [];


        const api_cancer_filters = _.keys(this.state.filters).filter(
            cancer_type => {
                return selectedValues.indexOf(
                    urlify(cancer_type)
                ) >= 0;
            }
        );


        if (api_cancer_filters.length > 0) {

            const filter_qs = {
                name: 'sample',
                op: 'has',
                val: {
                    name: 'cancer_type',
                    op: 'has',
                    val: {
                        name: 'name',
                        op: 'in',
                        val: api_cancer_filters
                    }
                }
            };

            current_api_qs.filter = [
                ..._.get(current_api_qs, 'filter', []),
                filter_qs
            ];
        }


        /*
         * Always request the aggregation.
         *
         * This is what supplies the options/counts for the filter.
         */
        current_api_qs.agg = {
            ..._.get(current_api_qs, 'agg', {}),
            ...this.aggregates
        };

        return current_api_qs;
    }


    processResponse(response) {

        const resp_agg = this.get_agg_values(response);
        const agg_field = _.keys(this.aggregates)[0];
        const count_field = this.aggregates[agg_field];

        /*
         * No aggregate returned.
         */
        if (
            !resp_agg ||
            !resp_agg[agg_field] ||
            !resp_agg[agg_field][count_field]
        ) {
            return;
        }


        const aggregateValues =
            resp_agg[agg_field][count_field];


        const activeCancerTypes =
            this.getActiveCancerTypes();


        const newfilters = {};


        /*
         * Build completely new objects.
         *
         * Do NOT mutate this.state.filters.
         */
        _.forEach(
            aggregateValues,
            (count, cancer_type) => {

                newfilters[cancer_type] = {
                    count: count,
                    active:
                        activeCancerTypes.indexOf(
                            urlify(cancer_type)
                        ) !== -1
                };
            }
        );


        /*
         * If a selected value isn't present in the current
         * aggregation, keep it visible/active.
         *
         * This prevents an active filter disappearing.
         */
        activeCancerTypes.forEach(activeValue => {

            const existingCancerType =
                _.find(
                    _.keys(newfilters),
                    cancerType =>
                        urlify(cancerType) === activeValue
                );

            if (!existingCancerType) {
                newfilters[activeValue] = {
                    count: 0,
                    active: true
                };
            }
        });


        /*
         * On a fresh mount where the URL already has an active
         * cancer_type (e.g. arriving from a direct link), the very
         * first request goes out before this.state.filters has ever
         * been populated -- so updateAPIURL has no way to translate
         * the urlified value in the URL into the real cancer type
         * name the API needs, and that first request is unfiltered.
         *
         * This aggregation response is what makes that translation
         * possible for the first time, so if we can now resolve an
         * active filter that wasn't applied yet, fire exactly one
         * follow-up request.
         */
        const isFirstPopulation = _.isEmpty(this.state.filters);

        const hasNewlyResolvableFilter = activeCancerTypes.some(
            activeValue => _.some(
                _.keys(aggregateValues),
                cancer_type => urlify(cancer_type) === activeValue
            )
        );

        const shouldSyncInitialSelection =
            isFirstPopulation &&
            hasNewlyResolvableFilter &&
            !this.hasSyncedInitialSelection;

        if (shouldSyncInitialSelection) {
            this.hasSyncedInitialSelection = true;
        }


        this.setState({
            filters: newfilters,
            activeCount: activeCancerTypes.length
        }, () => {
            if (shouldSyncInitialSelection) {
                this.props.requestAggregation();
            }
        });
    }


    toggleCheckbox(event) {

        const cancer_type = urlify(event.target.name);

        const current_qs = qs.parse(
            this.props.location.search,
            {
                ignoreQueryPrefix: true
            }
        );


        let cancerFilter = current_qs.cancer_type
            ? _.split(current_qs.cancer_type, '_')
            : [];


        if (event.target.checked) {

            if (cancerFilter.indexOf(cancer_type) === -1) {
                cancerFilter.push(cancer_type);
            }

        } else {

            cancerFilter = cancerFilter.filter(
                item => item !== cancer_type
            );
        }


        cancerFilter = _.uniq(cancerFilter).sort();


        if (cancerFilter.length > 0) {
            current_qs.cancer_type =
                _.join(cancerFilter, '_');
        } else {
            delete current_qs.cancer_type;
        }


        /*
         * Reset pagination when a filter changes.
         */
        delete current_qs.page;


        this.props.history.push(
            window.location.pathname +
            qs.stringify(
                current_qs,
                {
                    addQueryPrefix: true
                }
            )
        );
    }


    toggleCollapse() {

        this.setState({
            isOpen: !this.state.isOpen
        });
    }


    renderCancerTypeCheckboxes() {

        const filters = this.state.filters || {};


        let active = [];
        let inactive = [];


        _.forEach(
            _.toPairs(filters),
            ([key, filterProps]) => {

                const checkbox = (
                    <FormGroup
                        check
                        key={key}
                    >

                        <Input
                            type="checkbox"
                            name={key}
                            onChange={this.toggleCheckbox}
                            checked={!!filterProps.active}
                        />

                        {' '}

                        <Label
                            className="ml-4 mt-1"
                            check
                        >
                            {key}

                            {filterProps.count > 0 && (
                                <span className="secondary">
                                    {' '}({filterProps.count})
                                </span>
                            )}
                        </Label>

                    </FormGroup>
                );


                if (filterProps.active) {
                    active.push(checkbox);
                } else {
                    inactive.push(checkbox);
                }
            }
        );


        /*
         * Put active options first.
         */
        active = _.sortBy(
            active,
            element => element.key
        );

        inactive = _.sortBy(
            inactive,
            element => element.key
        );


        return (
            <Fragment>
                {active}
                {inactive}
            </Fragment>
        );
    }


    componentDidMount() {

        this.props.registerResponse(
            this.processResponse
        );

        this.props.registerRequest(
            this.updateAPIURL
        );
    }


    componentWillUnmount() {

        this.props.unregisterResponse(
            this.processResponse
        );

        this.props.unregisterRequest(
            this.updateAPIURL
        );
    }


    render() {

        return (
            <Card className="mb-2 z0 hover">

                <CardHeader
                    className="justify-content-between d-flex"
                    onClick={this.toggleCollapse}
                >

                    <div className="d-inline-block w-50">
                        Cancer Types
                    </div>

                    <div className="d-inline-block">

                        {this.state.activeCount > 0 && (
                            <strong>
                                {this.state.activeCount} active
                            </strong>
                        )}

                    </div>

                    <CollapseButton
                        isOpen={this.state.isOpen}
                        onClick={this.toggleCollapse}
                    />

                </CardHeader>


                <Collapse
                    isOpen={this.state.isOpen}
                >

                    <CardBody>
                        {this.renderCancerTypeCheckboxes()}
                    </CardBody>

                </Collapse>

            </Card>
        );
    }
}


export default withRouter(CancerTypeFilter);